<div bsModal #addFlagModal="bs-modal" class="modal fade" tabindex="-1" aria-modal="true" role="dialog"
  aria-labelledby="AddFlag" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-sm" style="width: 300px" role="document" [ngStyle]="modalStyle">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="AddFlag" class="modal-title">Add Flag</h4>
      </div>
      <div class="modal-body">
        <form [formGroup]="addFlagForm">
          <div class="form-group">
            <label for="name">What type of flag is it?</label>
            <select formControlName="flagType" class="form-control">
              <option *ngFor="let t of flagTypes" [ngValue]="t">{{ t.name }}</option>
            </select>
          </div>

          <div class="form-group" *ngIf="addFlagForm.get('flagType').value?.name == 'Violation'">
            <label for="name">and subtype?</label>
            <select formControlName="flagSubtype" class="form-control">
              <option *ngFor="let st of flagSubtypes" [ngValue]="st">{{ st?.name }}</option>
            </select>
          </div>

          <div class="form-group" *ngIf="scoresEnabled">
            <label for="name">Score</label>
            <div class="form-control" id="form-control">
              <input type="radio" [value]="0" formControlName="score" /> 0
              <input type="radio" [value]="1" formControlName="score" /> 1
              <input type="radio" [value]="3" formControlName="score" style="margin-left: 33px" /> 3<br />
              <input type="radio" [value]="5" formControlName="score" /> 5
              <input type="radio" [value]="10" formControlName="score" /> 10
              <input type="radio" [value]="100" formControlName="score" /> 100
            </div>
          </div>

          <div class="form-group">
            <label>Group</label>
            <ng-select #ngSelectComponent formControlName="group" [items]="groups" [addTag]="addTagFn" [hideSelected]="true"
              addTagText="Add new group" placeholder="Select or add a group" bindValue="name" bindLabel="name"
              [ngClass]="getValidationClass('group')" (change)="onGroupSelected($event)" (search)="onSearch($event)"
              (clear)="onClearSearch()">
              <ng-template ng-option-tmp let-item="item">
                <span [ngClass]="item.class">{{ item.name }}</span>
              </ng-template>
            </ng-select>
            <p *ngIf="addFlagForm.get('group').invalid && addFlagForm.get('group').touched" class="text-danger">
              This group already exists with a different type/subtype
            </p>
            </div>

          <div class="form-group">
            <label for="name">Note</label>
            <textarea formControlName="text" class="form-control"></textarea>
          </div>
          </form>
          <br />

        <div style="text-align: right">
          <button type="button" class="btn btn-sm btn-sm aru btn-secondary" (click)="cancel()">Cancel</button>&nbsp;
          <button type="button" class="btn btn-sm aru btn-primary" [disabled]="addFlagForm.invalid || saving" (click)="onSave()">
            Add Flag
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
